'use client';
import MobileDrawer from '@c/drawers/MobileDrawer';
import Filters from '@c/filters/Filters';
import { useCategoryFilters } from '@util/hooks/useCategoryFilters';
import { PageSideFilters } from '@util/hooks/useProductsPage';
import { CategoryDocument } from 'models/category';
import { FacetCounts } from 'models/product';
import { useCallback, useState } from 'react';

type MobileSearchFiltersProps = {
  showFilters: boolean;
  setShowFilters: (showFilters: boolean) => void;
  filterState: PageSideFilters;
  setFilterState: (filterState: PageSideFilters) => void;
  allBrands: string[];
  facet_counts: FacetCounts | undefined;
  categories?: CategoryDocument[];
  mostly_parts?: boolean;
  pageType: string;
};

export default function MobileSearchFilters({
  showFilters,
  setShowFilters,
  filterState,
  setFilterState,
  allBrands,
  facet_counts,
  categories,
  mostly_parts,
  pageType,
}: MobileSearchFiltersProps) {
  const {
    onResetFilters,
    handleFilterChange,
    handleCategoryChange,
    applyPendingFilterChanges,
    pendingFilterChanges,
    handleBikeSelection,
    handleSizeChange,
    handlePriceRangeChange,
  } = useCategoryFilters({
    filterState,
    setFilterState,
  });

  const [maxHeight, setMaxHeight] = useState(70);

  const handleScroll = useCallback((e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop } = e.currentTarget;

    const maxScroll = 100;
    const minHeight = 70;
    const maxHeight = 90;

    const scrollRatio = Math.min(Math.max(scrollTop / maxScroll, 0), 1);
    const newHeight = minHeight + (maxHeight - minHeight) * scrollRatio;

    setMaxHeight(newHeight);
  }, []);

  return (
    <MobileDrawer
      show={showFilters}
      dismiss={() => setShowFilters(false)}
      title="Filter"
      maxHeight={maxHeight}
      headerExtraButton={
        <button
          type="button"
          onClick={() => {
            onResetFilters();
            setShowFilters(false);
          }}
          className="px-[2rem] pt-[2rem] text-[2.1rem] font-semibold text-brand-secondary"
        >
          Reset
        </button>
      }
      onScroll={handleScroll}
    >
      <div className="px-8 pb-[10rem] pt-8">
        <Filters
          filterState={{ ...filterState, ...pendingFilterChanges }}
          handleFilterChange={handleFilterChange}
          handlePriceRangeChange={handlePriceRangeChange}
          handleCategoryChange={handleCategoryChange}
          allBrands={allBrands}
          facet_counts={facet_counts}
          categories={categories}
          mostly_parts={mostly_parts}
          handleBikeSelection={handleBikeSelection}
          handleSizeChange={handleSizeChange}
          pageType={pageType}
        />
      </div>

      <div className="absolute bottom-0 w-full bg-white p-6">
        <button
          type="button"
          className="w-full rounded-[2rem] bg-brand-secondary p-6 text-[2.1rem] font-semibold text-white"
          onClick={() => {
            applyPendingFilterChanges();
            setShowFilters(false);
          }}
        >
          Show Results
        </button>
      </div>
    </MobileDrawer>
  );
}
